<template>
  <div>
    <Banner />
    <div class="columns" style="justify-content: space-between">
      <div class="column is-8">
        <TextTitle
          :animate="true"
          :title="title"
          :fontWeight="language === 'en' ? 700 : 500"
        />
        <MainSpot :img="img" :info="info" id="main-spot" class="invisible" />
      </div>
      <div class="column is-3 is-hidden-mobile">
        <TextTitle
          :animate="true"
          :title="newsTitle"
          :fontWeight="language === 'en' ? 700 : 500"
        />
        <NewsSpot
          :news="news"
          :label="newsLabel"
          id="news-spot"
          class="invisible"
        />
      </div>
    </div>
    <HomeInformation />
    <div class="column is-3 is-hidden-tablet">
      <NewsSpot
        :news="news"
        :label="newsLabel"
        id="news-spot-mobile"
        class="invisible"
      />
    </div>
    <div class="partner-section">
      <TextTitle
        :animate="true"
        :title="partnerTitle"
        :fontWeight="language === 'en' ? 700 : 500"
      />
      <div class="partner">
        <Partner :animate="true" :imgHeight="80" @onloadTitle="setTitle" />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Home",
  components: {
    Banner: () => import(`@/components/Banner`),
    TextTitle: () => import(`@/components/TextTitle`),
    MainSpot: () => import(`@/components/MainSpot`),
    NewsSpot: () => import(`@/components/NewsSpot`),
    HomeInformation: () => import(`@/components/HomeInformation`),
    Partner: () => import(`@/components/Partner`),
  },
  data() {
    return {
      title: null,
      partnerTitle: null,
      info: [],
      img: null,
      news: [],
      newsTitle: null,
      newsLabel: null,
    };
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
  },
  watch: {
    language() {
      this.getMainNews();
      this.getTitle();
      this.getNews();
      this.setAnimation();
    },
  },
  mounted() {
    this.getMainNews();
    this.getTitle();
    this.getNews();
    this.setAnimation();
    $(document).scroll(this.setAnimation);
  },
  methods: {
    async getNews() {
      const me = this;
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["News","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      const data = res.data.results;
      data.forEach((arr) => {
        if (arr.type !== "news_header") {
          arr.data.body.forEach((item) => {
            me.news.push(item);
          });
        }
      });
      let sort = this.news.sort(function (a, b) {
        return new Date(b.primary.date) - new Date(a.primary.date);
      });
      sort = sort.slice(0, 3);
      this.news = sort;
    },
    async getMainNews() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["NewsHome","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      const data = res.data.results[0].data;
      this.title = data.title[0].text;
      this.info = data.info_list;
      this.img = data.img.url;
    },
    async getTitle() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["NewsSpotlight","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.newsTitle = res.data.results[0].data.title[0].text;
      this.newsLabel = res.data.results[0].data.label[0].text;
    },
    setTitle(title) {
      console.log(title);
      this.partnerTitle = title;
    },
    setAnimation() {
      const height = $(window).scrollTop() + $(window).height();
      if ($(`#main-spot`).length > 0) {
        if (height > $(`#main-spot`).offset().top) {
          $(`#main-spot`)
            .addClass("animate__animated animate__fadeInUp")
            .removeClass("invisible");
          $(`#news-spot`)
            .addClass("animate__animated animate__fadeInUp")
            .removeClass("invisible");
        }
        if (height > $(`#news-spot-mobile`).offset().top) {
          $(`#news-spot-mobile`)
            .addClass("animate__animated animate__fadeInUp")
            .removeClass("invisible");
        }
      }
    },
  },
  beforeDestroy() {
    const me = this;
    $(document).off("scroll", me.setAnimation);
  },
};
</script>
<style>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
<style scoped>
.partner {
  padding: 58px 0 111px;
}
@media (max-width: 768px) {
  .partner {
    padding: 23px 0 0 0px;
  }
  .partner-section {
    padding: 60px 0 50px;
  }
}
</style>
